import { render, staticRenderFns } from "./MyAlert.vue?vue&type=template&id=f630f8c4&"
import script from "./MyAlert.vue?vue&type=script&lang=js&"
export * from "./MyAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports